export default __webpack_public_path__ + "static/media/icon-minus-o.32c5bc02.svg";